<template>
	<div class="component-container">
		<div class="wall" :style="{'background-image':'url('+ title_screen.title_screen_repeating_bg +')'}"></div>
		<img class="background" :src="title_screen.title_screen_bg_elements" />
		<img class="title" :src="title_screen.title_screen_image" alt="Shady Sam" />
		<div class="enter-name">
			<input id="playerName" v-model="playerName" :placeholder="title_screen.enter_name" type="text" maxlength="20" v-on:keyup.13="submitPlayerName" />
			<Button class="startBtn" :action="submitPlayerName">{{title_screen.title_screen_button}}</Button>
			<p class="error" v-for="error in errors" :key="error.id">{{ error }}</p>
		</div>
	</div>
</template>

<script>
import Button from '@/components/abstract/Button';
import { mapState } from 'vuex';
import Filter from 'bad-words-relaxed';
import msEdgeImageSwap from '@/mixins/msEdgeImageSwap';

export default {
	name: 'Title',
	mixins: [msEdgeImageSwap],
	data() {
		return {
			playerName: null,
			errors: [],
			filter: new Filter(),
		};
	},
	components: {
		Button,
	},
	computed: {
		...mapState({ // get data from wordpress Game Stage config page
			title_screen: state => state.config.data.title_screen,
			game_config: state => state.config.data.game_config,
		}),
	},
	methods: {
		submitPlayerName() {
			if (this.playerName != null) {
				if (this.filter.isProfane(this.playerName)) {
					// is isProfane
					this.errors = [];
					this.errors.push(this.game_config.bad_word_error_message);
					document.getElementById("playerName").focus();
				} else {
					// is good
					const playername = this.toTitleCase(this.playerName);
					this.$store.commit('setPlayerName', playername);
					this.$router.push({ name: 'Welcome' });
				}
			} else {
				// is empty
				this.errors = [];
				this.errors.push('Name is required.');
				document.getElementById("playerName").focus();
			}
		},
		toTitleCase(str) {
			return str.toLowerCase().split(' ').map(word => word.replace(word[0], word[0].toUpperCase())).join(' ');
		},
	},
	mounted() {
		this.$store.commit('resetGame');
		this.swapEdgeImages();
	},
};
</script>

<style lang="scss" scoped>
	@import '../../assets/styles/utilities/**/*.scss';
	.component-container{
		width: 100%;
		height: 100%;
		position: absolute;
		display: inline-block;
		top: 0;
		left: 0;
	}
	.wall {
		width: 100vw;
		height: 100%;
		left: 50%;
		transform: translateX(-50%);
		position: absolute;
		background-position: top left;
		background-color: transparent;
		background-repeat: repeat-x;
		background-size: auto 100%;
		-webkit-filter: blur(0px);
	}
	.background{
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
	}
	.title{
		position: absolute;
		top: 9%;
		left: 50.2%;
		width: 34%;
		height: auto;
	}
	.enter-name{
		width: 34%;
		height: 26%;
		max-height: 140px;
		position: absolute;
		left: 49.75%;
		top: 53%;
		display: flex;
		align-items: center;
		justify-content: space-around;
		flex-direction: column;
		input{
			width: 80%;
			max-width: 250px;
			height: 40px;
			outline: none;
			border: 2px solid black;
			font-size: 1.1em;
			-webkit-appearance: none;
			border-radius: 0px;
			@include breakpoint(sm){
				width: 85%;
				font-size: 1em;
			}
			@include breakpoint(xsm) {
				width: 90%;
			}
			@include breakpoint(xs) {
				height: 30px;
				width: 100%;
			}
			&:focus{
				border: 2px solid black;
			}
		}
		.startBtn{
			min-height: 30px;
			margin: 0;
		}
		.error{
			color: white;
			margin: 0;
			position: absolute;
			height: 20px;
			bottom: -10px;
			@include breakpoint(xsm) {
				font-size: 0.875em;
				bottom: -15px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/views/Title.vue